import { render, staticRenderFns } from "./OrganismSidebar.vue?vue&type=template&id=331f95d4&"
import script from "./OrganismSidebar.vue?vue&type=script&lang=js&"
export * from "./OrganismSidebar.vue?vue&type=script&lang=js&"
import style0 from "./OrganismSidebar.vue?vue&type=style&index=0&id=331f95d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports